export const /** @type {?} */ FIRST_LOAN_SUCCESS_ROUTE = '/loan/success';
export const /** @type {?} */ MAINTENANCE_ROUTE = '/customer/dashboard/maintenance';
